export default __webpack_public_path__ + "static/Leaf9-41cbd28f5c4e9870dc4b1dcebc910f42.png";